<template>
	<v-img
		src="@/assets/images/editing-background-mobile.png"
		class="pt-13 px-5 px-sm-4"
	>
		<h2 class="mb-2 text-center sub--title primary--text">
			{{ $t('editing.sub-title') }}
		</h2>
		<h1 class="mb-8 text-center main--title white-space-pre">
			{{ $t('editing.title') }}
		</h1>
		<div class="point mb-5 d-flex align-center text-left">
			<div class="img-wrap mr-4">
				<img width="20" src="@/assets/images/thumbs-up-icon.png" alt="" />
			</div>
			<div v-html="$t('editing.point-1')"></div>
		</div>

		<div class="point mb-13 d-flex align-center text-left">
			<div class="img-wrap mr-4">
				<img width="20" src="@/assets/images/pen-and-note-icon.png" alt="" />
			</div>
			<div v-html="$t('editing.point-2')"></div>
		</div>
		<div class="chat-wrap pr-2 d-flex align-end justify-end mb-4">
			<div class="time mr-1">{{ $t('chat-time.am') }} 7:10</div>
			<div class="chat student">
				<p>The phone breaks up.<br />I can hardly hear you.</p>
			</div>
		</div>

		<div class="d-flex align-end mb-3">
			<img
				width="25"
				class="mr-1"
				src="@/assets/images/profile-tutor.png"
				alt=""
			/>
			<div class="tutor-name">Tella Tutor</div>
		</div>
		<div class="chat-wrap d-flex align-end justify-start mb-3">
			<div class="chat tutor" style="max-width: 65%">
				<p class="mt-1">
					>>> <span class="edit--text">*You are</span> breaking up.<br />
					I can hardly hear you.
				</p>
			</div>
			<div class="time ml-1">{{ $t('chat-time.am') }} 7:11</div>
		</div>
		<div class="chat-wrap d-flex align-end justify-start mb-5">
			<div class="chat tutor">
				<p class="mt-1">
					When you use the phrase
					<span class="font-weight-bold">‘to break up,’</span><br />
					you need to set the subject to
					<span class="font-weight-bold">‘you’</span>.
				</p>
			</div>
			<div class="time ml-1">{{ $t('chat-time.am') }} 7:12</div>
		</div>
		<div class="chat-explain pl-3 white-space-pre">
			{{ $t('editing.explain-in-chat') }}
		</div>
	</v-img>
	<!-- <v-row
		no-gutters
		style="max-width: 890px"
		class="pt-16 mt-4 mx-auto px-4"
		align="center"
	>
		<v-col cols="12" sm="6" class="pr-sm-16">
			<v-img src="@/assets/images/editing-background.png" class="px-3">
				<div class="chat-wrap pr-2 d-flex align-end justify-end mb-4">
					<div class="time mr-1">오전 7:10</div>
					<div class="chat student">
						<p>The phone breaks up.<br />I can hardly hear you.</p>
					</div>
				</div>
				<div class="chat-wrap d-flex align-end justify-start mb-3">
					<div class="chat tutor" style="max-width: 65%">
						<p class="mt-1">
							>>> <span class="edit--text">*You are</span> breaking up.<br />
							I can hardly hear you.
						</p>
					</div>
					<div class="time ml-1">오전 7:11</div>
				</div>
				<div class="chat-wrap d-flex align-end justify-start mb-4">
					<div class="chat tutor">
						<p class="mt-1">
							When you use the phrase
							<span class="font-weight-bold">‘to break up,’</span><br />
							you need to set the subject to
							<span class="font-weight-bold">‘you’</span>.
						</p>
					</div>
					<div class="time ml-1">오전 7:12</div>
				</div>
				<div class="chat-explain">
					‘To break up’ 이라는 표현을 사용하실 때는<br />
					주어를 ‘you’로 설정해줘야 해요.
				</div>
			</v-img>
		</v-col>
		<v-col cols="12" sm="6" class="pl-sm-11 text-left">
			<h2 class="mb-3 sub--title primary--text">마음껏 틀려도 괜찮아요</h2>
			<h1 class="mb-10 main--title">
				틀린 영어도 살려내는<br />1:1 실시간 첨삭
			</h1>
			<div>
				<div class="point mb-3 d-flex align-center">
					<img src="@/assets/images/thumbs-up-icon.png" alt="" class="mr-4" />
					<div>
						문법 오류와 영어 실수는<br /><span class="font-weight-bold"
							>꼼꼼하게 교정 받아요!</span
						>
					</div>
				</div>
				<div class="point mb-3 d-flex align-center">
					<img
						src="@/assets/images/pen-and-note-icon.png"
						alt=""
						class="mr-4"
					/>
					<div>
						어색한 한국식 영어대신<br /><span class="font-weight-bold">
							네이티브식 표현을 추천해줘요!</span
						>
					</div>
				</div>
			</div>
		</v-col>
	</v-row> -->
</template>

<script>
export default {}
</script>

<style lang="scss" scoped>
.point {
	width: 253px;
	margin: 0 auto;
	font-size: 16px;
	letter-spacing: -0.8px;
	color: #1a1a1a;
	.img-wrap {
		width: 40px;
		height: 40px;
		padding: 9.5px 9.5px 10.5px 10.5px;
		opacity: 0.87;
		border-radius: 10px;
		background-color: #fff;
	}
}

.chat-wrap .time {
	font-family: Pretendard;
	font-size: 7.2px;
	font-weight: 500;
	font-stretch: normal;
	font-style: normal;
	line-height: normal;
	letter-spacing: -0.36px;
	color: #b6b6b6;
}
.chat {
	text-align: left;
	p {
		margin-bottom: 0;
	}
}
.chat.student {
	padding: 15px 20px 15px 20px;
	object-fit: contain;
	background-color: #4a7cfb;
	border-radius: 15px;
	min-width: 172px;

	p {
		font-size: 13.8px;
		font-weight: 400;
		line-height: 1.33;
		letter-spacing: -0.32px;
		color: #fff;
	}

	@media screen and (max-width: 600px) {
		p {
			font-size: 15px;
			font-weight: 500;
		}
	}
}
@media screen and (max-width: 600px) {
	.chat.student {
		min-width: 188px;
	}
}

.tutor-name {
	font-weight: normal;
	font-stretch: normal;
	font-style: normal;
	line-height: 1.46;
	letter-spacing: -0.22px;
	color: #666;
}

.chat.tutor {
	padding: 15px 20px 15px 20px;
	box-shadow: 10px 16px 26px 0 rgba(33, 51, 82, 0.18);
	background-color: #fff;
	border-radius: 15px;
	p {
		font-size: 13.8px;
		font-weight: 400;
		line-height: 1.33;
		letter-spacing: -0.24px;
		color: #1a1a1a;

		.edit--text {
			color: #15c39a;
		}
	}
	@media screen and (max-width: 600px) {
		p {
			font-size: 15px;
			color: #1a1a1a;
			font-weight: 500;
		}
	}
}

.chat-explain {
	font-size: 11.9px;
	line-height: 1.46;
	letter-spacing: -0.21px;
	color: #666;
}
@media screen and (max-width: 600px) {
	.chat-explain {
		font-size: 13px;
	}
}
</style>
